import useEventListener from '@/core/hooks/useEventListener/useEventListener';

export default useEventListener;
